import React from 'react'

function CabezaPsychology(props) {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="15.166"
         height="17.149"
         viewBox="0 0 15.166 17.149"
         {...props}
      >
         <path
            fill={props.color}
            d="M16.207 16.432a.693.693 0 10-.464-.2.639.639 0 00.464.2zm-.453-2.144h.905a1.806 1.806 0 01.06-.536 1.517 1.517 0 01.274-.441q.1-.1.214-.238t.238-.262a3.159 3.159 0 00.476-.679 1.44 1.44 0 00.143-.631 1.547 1.547 0 00-.488-1.191 1.834 1.834 0 00-1.3-.453 2.1 2.1 0 00-1.2.345 1.861 1.861 0 00-.726.965l.834.333a1.056 1.056 0 011.048-.81.927.927 0 01.667.25.836.836 0 01.262.631.88.88 0 01-.107.417 1.925 1.925 0 01-.345.441 4.518 4.518 0 01-.369.333 1.322 1.322 0 00-.3.333 1.6 1.6 0 00-.214.488 2.855 2.855 0 00-.071.7zm-2.691 8.86v-3.024h-1.691a1.423 1.423 0 01-1.429-1.429v-2.644H8.99a.765.765 0 01-.715-.453.927.927 0 01.025-.928l1.643-2.953a7.624 7.624 0 012.417-4.085A6.291 6.291 0 0116.659 6a6.628 6.628 0 016.669 6.669 5.851 5.851 0 01-1.179 3.585 8.072 8.072 0 01-2.989 2.465v4.43zm3.572-10.67zm-2.143 9.242h3.239v-3.93l.667-.31a6.785 6.785 0 002.5-1.941 4.466 4.466 0 001-2.87 5.2 5.2 0 00-5.24-5.24 5.369 5.369 0 00-3.573 1.286A4.48 4.48 0 0011.443 12L9.99 14.622h1.381v4.073h3.12z"
            transform="translate(-8.162 -6)"
         ></path>
      </svg>
   )
}

export default CabezaPsychology
